import axios from "./axiosConfig";

const BASE_URL = "/quotation";

// Get paginated quotations
export const getQuotations = async (page, limit) => {
    const response = await axios.get(`${BASE_URL}?page=${page}&pageSize=${limit}`);
    const { success, message, data } = response.data;

    if (success) {
        return data; // { data: [], currentPage, totalItems, totalPages }
    } else {
        throw new Error(message || "Failed to fetch quotations");
    }
};

// Create quotation
export const createQuotation = async (quotation) => {
    const response = await axios.post(`${BASE_URL}/create`, quotation, {
        headers: { "Content-Type": "application/json" },
    });

    const { success, message, data: resultData } = response.data;
    if (success) {
        return response.data; // return created quotation with Id + QuotationNumber
    } else {
        throw new Error(message || "Creation failed");
    }
};

// Update quotation
export const updateQuotation = async (id, quotation) => {
    const response = await axios.put(`${BASE_URL}/update/${id}`, quotation, {
        headers: { "Content-Type": "application/json" },
    });

    const { success, message, data } = response.data;
    if (success) {
        return response.data; // return updated quotation
    } else {
        throw new Error(message || "Update failed");
    }
};

// Soft delete quotation
export const deleteQuotation = async (id) => {
    const response = await axios.delete(`${BASE_URL}/delete/${id}`);
    const { success, message } = response.data;
    debugger;
    if (success) {
        return true;
    } else {
        throw new Error(message || "Delete failed");
    }
};

export const openQuotationPdf = async (id) => {
    try {
        const response = await axios.get(`${BASE_URL}/pdf/${id}`, {
            responseType: 'blob',
        });

        const blob = response.data; // <-- axios gives blob here directly
        const contentDisposition = response.headers['content-disposition'];
        let filename = "download.pdf";
        debugger;
        // Extract filename if available
        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
                filename = match[1].replace(/['"]/g, '');
            }
        }

        // Create and trigger download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading PDF:", error);
        alert("Failed to download PDF");
    }
};